import gql from 'graphql-tag'
import { SpaceTypeFragment } from '@api/fragments'
import { ISpaceTypeWithCompany } from '@api/types'
import client from '@stores/apollo'

export default function details(id: string) {
  return client.gql
    .query({ query, variables: { id } })
    .then(({ data: { node: space } }: { data: { node: ISpaceTypeWithCompany } }) => space)
}

const query = gql`
  query spaceTypeDetails($id: ID!) {
    node(id: $id) {
      ... on SpaceType {
        ...SpaceTypeFragment
        company {
          id
        }
      }
    }
  }
  ${SpaceTypeFragment}
`
